import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppForumListPage } from './app-forum-list';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppForumListPage,
  ],
  imports: [
    IonicPageModule.forChild(AppForumListPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppForumListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-forum-list/app-forum-list.module.ts